import React from "react";

import ApplicationLayout, { applicationStyles as styles } from "../ApplicationLayout";
import WithUserForm from "../../Register/WithUserForm";

const Success = () => (
  <WithUserForm>
    {() => (
      <ApplicationLayout centred>
        <div className={styles.centred}>
          <div className={styles.successIcon}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#B08D57" strokeWidth="2" aria-hidden="true">
              <path d="M5 12.5 10 17.5 19 7" />
            </svg>
          </div>
          <h1 className={`${styles.title} ${styles.successTitle}`}>Thank you for applying</h1>
          <p className={styles.intro} style={{ margin: 0 }}>
            We'll review your application and reply by email.
          </p>
          <p className={styles.tagline}>Beauty is in the Eye of the Employer&reg;</p>
        </div>
      </ApplicationLayout>
    )}
  </WithUserForm>
);

export default Success;
